import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-coal py-12 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-81" data-mp="4vs0dxwxedqv">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-82" data-mp="9sry9ljmga6w">
        <Medallion icon={ShieldCheckIcon} data-id="element-83" data-mp="etz61klrl9dk" />

        <p className="eyebrow mt-6 text-gold" data-id="element-84" data-mp="eur20wj9x94d">Garantía de 7 días</p>
        <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-display text-[1.9rem] font-bold leading-[1.12] text-ivory sm:text-4xl" data-id="element-85" data-mp="jrhgjfffjwno">
          100% o devolución total
        </h2>

        <p className="mx-auto mt-6 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-86" data-mp="skkrnh2lrxf5">
          Accedé al sistema completo. Revisá los 6 volúmenes. Probá las sesiones
          con tus atletas. Consultá los bonos.
        </p>
        <p className="mx-auto mt-4 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-87" data-mp="12kv06odp0gnz">
          Si en los próximos 7 días sentís que el material no es claro, práctico
          o útil para tu entrenamiento, escribinos y te devolvemos tu dinero.{' '}
          <span className="font-medium text-ivory" data-id="element-88" data-mp="20rsr0st5zr6n">
            Sin preguntas, sin complicaciones.
          </span>
        </p>
      </div>
    </section>;
}